import { render, staticRenderFns } from "./AllWebsites.vue?vue&type=template&id=2bbb85b8&"
import script from "./AllWebsites.vue?vue&type=script&lang=ts&"
export * from "./AllWebsites.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports